import { student_essay, user_id } from './../services/College_name.service';
import { Test_Taker } from './../test_taker/test_taker.model';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { College_Names, collegedetails, CollegeService, UserSet, scoreid } from '../services/College_name.service';
import { Year } from '../services/year.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Local, questionService } from '../services/question.service';
import { RowHeightService } from '@progress/kendo-angular-grid/dist/es2015/scrolling/row-height.service';
declare var $: any;
declare let jQuery: any;

@Component({
  selector: 'app-essay-evaluation-view',
  templateUrl: './essay-evaluation-view.component.html',
  styleUrls: ['./essay-evaluation-view.component.scss']
})
export class EssayEvaluationViewComponent implements OnInit {
  Collegeid: any;
  //mark:string = '';
  @ViewChild("mark") modalMark: TemplateRef<any>;
  hideModal: boolean;
  score: scoreid = { userid: '', question_category_id: '',question_sub_category_id: '',question_type_id:'', complexity_id: '', correct_ans: '', mark: '',comments:""  }
  highlightedRows = [];
  getscore: user_id = { user_id: '',type:''}
  public dictionary: any;
  public mark: string = '';
  yearid: any;
  Collegedetails: collegedetails = { collegeid: '', yearid: '',setid:'' };
  userset: UserSet = { userid: '', setid: '',type_name:'' };
  searchKey: string;
  displayedColumns: string[] = ['S.No.', 'Roll_Number', 'First_Name', 'View_Essay', 'View_Algorithm'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  userid: any;
  local: Local = { Id: '', paper: '', set: '', schedule: '', email: '',schedule_master_Id:'' };
  modalService: any;
  essay: any;
  college: any;
  College_Name1: any;
  Year_Name: any;
  College_Name: any;
  dataSource: MatTableDataSource<any>;
  student: student_essay = {id:'',type:''};
  show: boolean;
  questions: any;
  id: any;
  cat_Id: any;
  cat: string;
  set: string;
  paper: string;
  qset: string;
  essayqs: any;
  questions1: any;
  candidateid: any = [];
  save_essay: any;
  evaluated: any = [];
  temp_report: any;
  user_id: any;
  userscore: any;
  errorMsg: string;
  IsmodelShow: boolean;
  modalRef: any;
  rowmark :any= [];
  rowmarks :any= [];
  algmarks: any=[];
  algmark:any=[];
  essayrowmark: any;
  //emptydata: boolean = false;
  essaypara: string;
  updatemarks: boolean;
  visible: boolean;
  scorecheck: boolean;
  percent: number;
  alg: number = 0;
  essay_data: any;
  category_name: any;
  no_data: boolean = true;
  qsid: string;
  user: string;
  userAdmin: boolean;
  userTestScheduler: boolean;
  userSuperAdmin: boolean;

  constructor(private router: Router, private fs: CollegeService, private modal: NgbModal, private route: ActivatedRoute, private quest: questionService) {
    // this.display_essay();

    this.dictionary = {
      dictionaryUrl: "http://js.syncfusion.com/ejServices/api/SpellCheck/CheckWords",
      customDictionaryUrl: "http://js.syncfusion.com/ejServices/api/SpellCheck/AddToDictionary"
    };
  }
  ngOnInit() {
    this.getAccess();






    //  this.rowmarks = []

    this.rowmarks = JSON.parse(localStorage.getItem('rowmark'));
    this.algmarks = JSON.parse(localStorage.getItem('algmark'));


    if (this.rowmarks === undefined || this.rowmarks === null) {
      localStorage.setItem("rowmark", JSON.stringify([111]))
      this.rowmarks = JSON.parse(localStorage.getItem('rowmark'));
    }
    if (this.algmarks === undefined || this.algmarks === null) {
      localStorage.setItem("algmark", JSON.stringify([111]))
      this.algmarks = JSON.parse(localStorage.getItem('algmark'));
    }
    //this.rowmarks = Object.values(this.rowmarks);



    this.qset = localStorage.getItem('qsid')

    //this.dataSource.paginator = this.paginator;
    this.display_candidates();

    //  this.display_question();
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.cat_Id = this.id;
      this.cat = localStorage.getItem('Category-id');

      this.set = localStorage.getItem('Set-id');

      this.paper = localStorage.getItem('Paper-id');



    });

    this.local.Id = 3
    this.local.set = this.set
    this.local.paper = this.paper

  }

  display_alg(row){
    this.userset.userid = row.id;
    this.userset.type_name = 'Algorithm'
    this.display_question(row);
  }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    if (this.user === '2') {

      this.userAdmin = true;
      this.userSuperAdmin = false;
      this.userTestScheduler = true;
    } else if (this.user === '1') {

      this.userAdmin = true;
      this.userSuperAdmin = true;
      this.userTestScheduler = true;
    } else if (this.user === '3') {
      this.userAdmin = false;
      this.userSuperAdmin = false;
      this.userTestScheduler = true;
    }
  }

  display_essay(row){
    this.userset.userid = row.id;
    this.userset.type_name = 'None'
    this.display_question(row);
  }

  // display_essay_ans(row) {

  //
  //
  //   //this.emptydata = false

  //   // let ngbModalOptions: NgbModalOptions = {
  //   //   backdrop: 'static',
  //   //   keyboard: false,
  //   // };
  //   //



  //
  //

  //
  //   this.fs.display_essay(this.student).subscribe(
  //     (data) => {

  //
  //       this.questions = data.results;
  //       // if(data.results.length == 0){
  //       //   this.emptydata = true
  //       //   this.essaypara = 'No Essay'
  //       // }
  //
  //       this.temp_report = data.results;
  //
  //       this.essay = data.results[0].Essay_Answer;
  //

  //     },
  //     err => {
  //       console.error(err);
  //     }
  //   );


  // }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }
  back() {
    this.router.navigate(['evaluate_essay']);
  }


  display_candidates() {

    this.Collegeid = localStorage.getItem('CollegeId')
    this.qsid = localStorage.getItem('qsid')
    this.yearid = localStorage.getItem('Yearid')
    this.Collegedetails.collegeid = this.Collegeid;
    this.Collegedetails.yearid = this.yearid;
    this.Collegedetails.setid = this.qsid;


    this.fs.display_essay_candidate(this.Collegedetails).subscribe(
      (data) => {


        this.college = data.results;
        //this.temp_report=data.results;
        for (var i = 0; i < data.results.length; i++) {
          this.candidateid[i] = data.results[i].id;

        }



        this.College_Name1 = this.college[0].College_Name

        this.Year_Name = this.college[0].Year


        //
        console.log("this.colege",this.college)

        this.dataSource = new MatTableDataSource(this.college);
        this.dataSource.sort = this.sort;
        setTimeout(() => this.dataSource.paginator = this.paginator);

        // this.display_scoreid();
      },
      err => {
        console.error(err);
      }

    );

  }

  display_algorithm_ques(row){

    this.show = true
    this.userset.userid = this.student.id;
    this.userset.setid = this.qset;
    this.userset.type_name = 'Algorithm'
    this.fs.display_ques(this.userset).subscribe(
      (data) => {


        this.questions1 = data.result

        this.essayqs = this.questions1[0].Question_Text;

        this.get_score(row)
        // for(var i=0;i<data.result.length;i++){
        //   this.temp_report[i].Test_Taker_User_Id=false
        // }

      },
      err => {
        console.error(err);
      }
    );
  }

  display_question(row) {
    this.no_data = true;

    this.userset.setid = this.qset;
    console.log(row);

     //Open modal on pressing escape
     let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
    this.fs.display_ques(this.userset).subscribe(
      (data) => {
        console.log("questions1 inside dis",data.result)


        this.questions1 = data.result
        this.essay_data = data.result;

        if (this.essay_data === undefined || this.essay_data === null || this.essay_data.length ==0) {
          // this.essay_data = 'No data available'
          this.category_name = 'Comprehension';
          this.no_data = false;
          this.essay_data = [{  Essay_Answer: 'No data available' }];
        }
        else{
          this.category_name = this.essay_data[0].Category_Name;
        }
        //
        this.showurl(this.questions1[0])
        // for(var i=0;i<data.result.length;i++){
        //   this.temp_report[i].Test_Taker_User_Id=false
        // }

      },
      err => {
        console.error("Error",err);
      }
    );
  }
  // display_scoreid(){

  //

  //   this.fs.display_scoreid(this.candidateid).subscribe(
  //     (data) => {

  //
  //       this.questions1=data.result
  //
  //       this.essayqs = this.questions1[0].Question_Text;
  //

  //     },
  //     err => {
  //       console.error(err);
  //     }
  //   );
  // }
get_essay_score(row){
  this.getscore.type = 'None';
  // this.get_score(row)
}

get_alg_score(row){
  this.getscore.type = 'Algorithm';
  // this.get_score(row)
}

showurl(row){
    
  this.getscore.user_id = row.Id;
  this.getscore.type = row.Name;
 
  this.fs.getscore(this.getscore).subscribe(
    data => {

    if(data.results.length >0)
      this.userscore = data.results[0].score;
    else{
      this.userscore = 0;
    }
    console.log(this.userscore);
      

      // if(this.userscore = 0){
      //   this.scorecheck = true;
      // }
      // else{
      //    this.scorecheck=false
      // }

    }
  )



}
  get_score(row) {

    this.getscore.user_id = row.id;
    this.getscore.type = row.Name;
    this.user_id = this.college

    this.fs.getscore(this.getscore).subscribe(
      data => {

        if(data.results.length >0)
          this.userscore = data.results[0].score;
        else{
          this.userscore = 0;
        }
          console.log(this.userscore);

        // if(this.userscore = 0){
        //   this.scorecheck = true;
        // }
        // else{
        //    this.scorecheck=false
        // }

      }
    )
  }
  getmarks(row) {


    //this.rowmarks = []
    console.log(row);
    this.rowmarks = JSON.parse(localStorage.getItem('rowmark'));
    this.algmarks = JSON.parse(localStorage.getItem('algmark'));
    //this.rowmarks = Object.values(this.rowmarks);




    
    //this.highlightedRows.push(this.rowmark)
    if (this.userscore == undefined) {
      const modalRef = this.modal.open(this.modalMark)
      this.errorMsg = "Marks field is empty"
    }
    else if (this.userscore > 100) {
      const modalRef = this.modal.open(this.modalMark)
      this.errorMsg = "Enter marks below 100%"
    }
    else if (this.userscore < 0 || this.userscore == 0) {
      const modalRef = this.modal.open(this.modalMark)
      this.errorMsg = "Enter valid marks"
    }
    else {
      this.modalRef.close(this.modalContent)


        
      if(row.Name == 'None'){
          this.rowmarks.push(row.Roll_Number)
          console.log(row.Roll_Number)
          localStorage.setItem("rowmark", JSON.stringify(this.rowmarks))

      }
      else{
          this.algmarks.push(row.Roll_Number)
          console.log(row.Roll_Number)
          localStorage.setItem("algmark", JSON.stringify(this.algmarks))
      }


      


      //this.rowmarks = Object.values(this.rowmarks);

      console.log("questions1",this.questions1)


      this.score.userid = row.Test_Taker_User_Id;
      this.score.complexity_id = this.questions1[0].Complexity_Id;
      this.score.question_category_id = this.questions1[0].Question_Category_Id;
      this.score.question_sub_category_id = this.questions1[0].Question_Sub_Category_Id;
      this.score.question_type_id = this.questions1[0].Question_Type_Id
      this.score.correct_ans = this.questions1.length;
      this.score.mark = this.userscore;
      
      console.log(row);

      // this.changecolor(row)
      this.fs.save_essay_mark(this.score).subscribe(
        data => {
          this.save_essay = data.results;

        },
        err => {
          console.error(err);
        }
      );
    }
  }

  //    checkErrors() {
  //     let spellObj = $('#SpellCheck').data('ejSpellCheck');
  //     spellObj.validate();
  // }

  // changecolor(row) {
  //
  //   let color;
  //   //let color;
  //
  //   if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {

  //     color = 'rgb(23, 162, 184)';
  //   }
  //   return color;
  // }

  change_visibility(row) {

    let visibility;
    if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {
      visibility = 'hidden';
      this.visible = true;
    }

  }
}



